'use strict'

// fetch() polyfill — kept as a safety net since the app relies heavily on fetch.
// Native fetch exists in all modern browsers but the polyfill ensures consistent behavior.
require('whatwg-fetch')
